import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import StatusChip from '../StatusChip';
import { formatDateTime } from '../../changelogAdminConfig';

const HEADERS = ['Nome', 'Empresa', 'E-mail', 'Situação', 'Enviado em', 'Abriu em', 'Clicou em'];

const STATUS = {
  sent: { label: 'Enviado', color: '#2E7D32', bg: '#E8F5E9' },
  pending: { label: 'Pendente', color: '#5A80FB', bg: '#EEF2FF' },
  failed: { label: 'Falha', color: '#C62828', bg: '#FDECEA' },
  skipped: { label: 'Ignorado', color: '#64748B', bg: '#F1F5F9' },
};

const cellSx = { fontSize: '0.8125rem', verticalAlign: 'top' };

function RecipientRow({ recipient }) {
  const status = STATUS[recipient.status] || STATUS.pending;
  const clicked = Array.isArray(recipient.clicked_targets) ? recipient.clicked_targets : [];
  return (
    <TableRow hover>
      <TableCell sx={{ ...cellSx, fontWeight: 600 }}>{recipient.name || '—'}</TableCell>
      <TableCell sx={cellSx}>{recipient.companies || '—'}</TableCell>
      <TableCell sx={{ ...cellSx, wordBreak: 'break-all' }}>{recipient.email}</TableCell>
      <TableCell sx={cellSx}>
        <StatusChip info={status} />
        {recipient.error_message && (
          <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 0.5, maxWidth: 220 }}>
            {recipient.error_message}
          </Typography>
        )}
      </TableCell>
      <TableCell sx={{ ...cellSx, whiteSpace: 'nowrap' }}>{formatDateTime(recipient.sent_at)}</TableCell>
      <TableCell sx={{ ...cellSx, whiteSpace: 'nowrap' }}>{formatDateTime(recipient.first_opened_at)}</TableCell>
      <TableCell sx={cellSx}>
        {clicked.length === 0 ? '—' : (
          <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', maxWidth: 260 }}>
            {clicked.map((item) => (
              <Chip key={item.target} size="small" variant="outlined" label={item.label} />
            ))}
          </Box>
        )}
      </TableCell>
    </TableRow>
  );
}

/**
 * Tabela dos destinatários de um envio (situação do envio, abertura e cliques).
 * @param {{ recipients: Array, isLoading: boolean, hasActiveFilters: boolean }} props
 */
function EditionRecipientsTable({ recipients, isLoading, hasActiveFilters }) {
  return (
    <TableContainer sx={{ overflowX: 'auto' }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ bgcolor: '#F8F9FC' }}>
            {HEADERS.map((label) => (
              <TableCell key={label} sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.8125rem', whiteSpace: 'nowrap' }}>
                {label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                <CircularProgress size={32} />
              </TableCell>
            </TableRow>
          ) : recipients.length === 0 ? (
            <TableRow>
              <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                <Typography variant="body2" color="text.secondary">
                  {hasActiveFilters ? 'Ninguém com esses filtros' : 'Este envio ainda não saiu'}
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            recipients.map((recipient) => <RecipientRow key={recipient.send_id} recipient={recipient} />)
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default EditionRecipientsTable;
